/*
  breadcrumbs
*/
/**
 * Desktop/Mobile BREADCRUMBS script
 * Works with options & page code name
 */
  var filter = "hmp_in,hmp_out,hmp,evtp";
  filter = filter.split(",");

  var option = $("input[data-name=brdcrmbs]");
  var desk_breadcrumbs = $(".desk_breadcrumbs-1");
  var mob_breadcrumbs = $(".mob_breadcrumbs-1");
  var desk_breadcrumbs_val = "";
  var mob_breadcrumbs_val = "";

  //== displaying breadcrumbs
  if (!in_array(PAGE_CODE, filter) && PAGE_CODE) {
    mob_breadcrumbs.show();
    desk_breadcrumbs.show();
    $("main").addClass("has-breadcrumbs");
  }




//== creating breadcrumbs
//== init
var option_val = "";

  //== creating breadcrumbs for WL
  if (option.length) {

    //== if option input is found, store its value
    option_val = option.val();
  }
  //== creating breadcrumbs for CB
  else if (typeof GROUPS !== "undefined" && GROUPS.length) { //GROUPS is from bundle.js

    //== init
    var page_group = {};
    var brdcrmbs_option = {};

    //== select the page group
    for (var i = 0; i < GROUPS.length; i++) {
      //== get
      var _group = GROUPS[i];

      //== get group type & code name
      var group_type = _group.Group_Type;
      var group_code_name = _group.Code_Name;

      //== store group if its the current page
      if (group_type === "page" && group_code_name === PAGE_CODE) {
        page_group = _group;
      }
    }
    //== if group found
    if (!$.isEmptyObject(page_group)) {

      //== get its options
      var group_options = page_group.Options;

      //== search for breadcrumbs option
      for (var i = 0; i < group_options.length; i++) {

        //== get
        var _option = group_options[i];

        //== check if its a brdcrmbs option
        if (_option.Code_Name === "brdcrmbs") {

          //== store
          brdcrmbs_option = _option;
        }
      }

      //== if option is found
      if (!$.isEmptyObject(brdcrmbs_option)) {

        //== get its value
        option_val = group.replaceTokens(brdcrmbs_option.Val);
      }
    }
  }






  //== ASSIGN BREADCRUMBS
  //-- we split using , because if the breadcrumbs is composed of multiple elements, they are separaed by a , in the DB
  option_val = option_val.split(",");

  if ($.trim(option_val)) {

    //== creating desktop breadcrumbs
    for (var el in option_val) { desk_breadcrumbs_val += " &gt; " + option_val[el]; }

    //== end
    desk_breadcrumbs.find(".text").html(desk_breadcrumbs_val);
    mob_breadcrumbs.find(".text").html(option_val[option_val.length - 1]); // the mobile breadcrumbs just takes the last element
  }
